var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRpmMonitor2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_2",
    "data-name": 2,
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M13,20H10.35a1.3,1.3,0,0,1-1.3-1.3V2.59H3.95V18.55a1.3,1.3,0,0,1-1.3,1.3H0V17.26H1.35V1.3A1.3,1.3,0,0,1,2.65,0h7.7a1.3,1.3,0,0,1,1.3,1.3V17.41H13Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRpmMonitor2);
export default __webpack_public_path__ + "static/media/rpm_monitor_2+.4585ab13bd8b32e2cf3826b8a6d43641.svg";
export { ForwardRef as ReactComponent };